import React, { useState } from "react";
import "react-circular-progressbar/dist/styles.css";
import ProgressBarItem from "./ProgressBarItem";
import { useSelector } from "react-redux";

export default function AiWheelProgressBar() {
  const { pending } = useSelector((state) => state.userWheels);
  const [viewAll, setViewAll] = useState(pending?.length <= 3);

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      {!viewAll ? (
        <ProgressBarItem
          setViewAll={() => setViewAll(true)}
          totalItems={pending?.length}
          item={pending[0]}
        />
      ) : (
        pending.map((item) => {
          return (
            <ProgressBarItem
              viewAll={viewAll}
              totalItems={pending?.length}
              item={item}
            />
          );
        })
      )}
    </div>
  );
}
